import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/lib/useFetch";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { PageTitle, Empty } from "@/components/layout/DashShell";
import { Loader } from "@/components/Blocks";
import { Input } from "@/components/ui/input";

const Th = ({ cols }) => <thead className="bg-[#F4F6FA] text-left text-xs uppercase tracking-wider text-[#475569]"><tr>{cols.map((c) => <th key={c} className="p-3">{c}</th>)}</tr></thead>;

const run = async (fn, ok, reload) => {
  try { await fn(); toast.success(ok); reload(); } catch (e) { toast.error(errMsg(e)); }
};

const OwnerTools = ({ data, reload }) => {
  const [url, setUrl] = useState(data.marketplace_url || "");
  const [email, setEmail] = useState("");
  return (
    <div className="mb-6 grid gap-4 lg:grid-cols-2">
      <div className="panel space-y-2 p-5">
        <div className="eyebrow">Private Marketplace link</div>
        <p className="text-xs text-[#475569]">Shown only to signed-in lecture graduates. Never shown publicly.</p>
        <div className="flex gap-2"><Input placeholder="https://www.tradingview.com/..." value={url} onChange={(e) => setUrl(e.target.value)} data-testid="indicator-url-input" />
          <button className="btn-navy" onClick={() => run(() => api.put("/admin/indicator-settings", { marketplace_url: url.trim() }), "Link saved", reload)} data-testid="indicator-url-save-btn">Save</button></div>
      </div>
      <div className="panel space-y-2 p-5">
        <div className="eyebrow">Owner override</div>
        <p className="text-xs text-[#475569]">Let an account buy without a recorded check-in.</p>
        <div className="flex gap-2"><Input type="email" placeholder="student@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="indicator-override-email-input" />
          <button className="btn-navy" onClick={() => run(() => api.post("/admin/indicator/override", { email, allowed: true }), "Override added", reload)} data-testid="indicator-override-add-btn">Allow</button></div>
        {data.overrides.map((u) => (
          <div key={u.id} className="flex items-center justify-between border-t pt-2 text-sm" data-testid={`indicator-override-${u.id}`}>
            <span>{u.name} · {u.email}</span>
            <button className="text-xs font-semibold text-[#C8382E]" onClick={() => run(() => api.post("/admin/indicator/override", { email: u.email, allowed: false }), "Override removed", reload)} data-testid={`indicator-override-remove-${u.id}`}>Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function IndicatorAdmin() {
  const { user } = useAuth();
  const { data, loading, reload } = useFetch("/admin/indicator");
  if (loading || !data) return <Loader />;
  const todo = data.requests.filter((r) => r.status === "to_grant").length;
  return (
    <>
      <PageTitle title="Indicator access to grant" sub={`${todo} waiting. Add each username to the indicator on TradingView, then mark it granted.`} />
      {user?.role === "owner" && <OwnerTools data={data} reload={reload} />}
      {data.requests.length === 0 ? <Empty>No usernames submitted yet.</Empty> : (
        <div className="panel overflow-x-auto"><table className="w-full text-sm" data-testid="indicator-requests-table"><Th cols={["Graduate", "TradingView username", "Eligible by", "Submitted", "Status", ""]} /><tbody>
          {data.requests.map((r) => (
            <tr key={r.id} className="border-t" data-testid={`indicator-row-${r.id}`}>
              <td className="p-3">{r.name}<div className="text-xs text-[#475569]">{r.email}</div></td>
              <td className="p-3 font-mono-num">{r.username}</td>
              <td className="p-3 text-xs">{r.via === "owner_override" ? "Owner override" : "Check-in"}</td>
              <td className="p-3 text-xs">{fmtDateTime(r.created_at)}</td>
              <td className="p-3 text-xs font-semibold">{r.status === "granted" ? "Granted" : "To grant"}</td>
              <td className="p-3">{r.status === "to_grant"
                ? <button className="btn-outline text-xs" onClick={() => run(() => api.put(`/admin/indicator/${r.id}`, { status: "granted" }), "Marked granted", reload)} data-testid={`indicator-grant-${r.id}`}>Mark granted</button>
                : <button className="text-xs text-[#475569] underline" onClick={() => run(() => api.put(`/admin/indicator/${r.id}`, { status: "to_grant" }), "Moved back", reload)} data-testid={`indicator-ungrant-${r.id}`}>Undo</button>}</td>
            </tr>
          ))}
        </tbody></table></div>
      )}
    </>
  );
}
